import React   from 'react' ;
import PageCh12_t1 from './pageCh12_t1';
import PageCh12_t2 from './pageCh12_t2'; 
const   PageCh12 = ()=>{
     
       
    return (
      <>  <hr/> 
      <h1 className="m-2" >PageCh12 (chapter 12)</h1>
       <PageCh12_t1 />  
       <PageCh12_t2 />  
      </>
    )
     
} 
export default PageCh12
